import { render } from "./createstocktransfer.vue?vue&type=template&id=c56037de&scoped=true"
import script from "./createstocktransfer.vue?vue&type=script&lang=js"
export * from "./createstocktransfer.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./createstocktransfer.vue?vue&type=style&index=1&id=c56037de&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56037de"]])

export default __exports__